

let initialState = [
    {comment : "Hallo Welt"}
];
function events(state = initialState, action) {
    if (action.type === "EVENT_ADD") {
        return [].concat(state, [
            { comment: action.comment}
        ])
    }
    return state;
}

export default events;